import UploadedFile from './UploadedFile-compose';

export default UploadedFile;
